module.exports = __webpack_public_path__ + "static/unesco-marquises-b10774dca116380666eb707baf34db91.png";